import { t } from 'i18next';
import { clientConfig } from 'pos-client/clientConfig.ts';

export const stockOverviewTabs = {
  stockLevels: {
    key: clientConfig.locale === 'en-US' ? 'inventory-levels' : 'stock-levels',
    label: t('stock.stockLevels'),
  },
  deliveries: {
    key: 'deliveries',
    label: t('stock.deliveries.deliveries'),
  },
  transfers: {
    key: 'transfers',
    label: t('stock.transfers.transfers'),
  },
  adjustments: {
    key: 'adjustments',
    label: t('stock.adjustments.adjustments'),
  },
  quarantine: {
    key: 'quarantine',
    label: t('stock.quarantine.quarantine'),
  },
  returns: {
    key: 'returns',
    label: t('stock.returns.returns'),
  },
  purchaseOrders: {
    key: 'purchase-orders',
    label: t('purchaseOrders.purchaseOrders'),
  },
};

export const stockTakesTabs = {
  stockTakes: {
    key: clientConfig.locale === 'en-US' ? 'inventory-checks' : 'stock-takes',
    label: t('stock.stockTakes.stockTakes'),
  },
  stockTakeProfiles: {
    key:
      clientConfig.locale === 'en-US'
        ? 'inventory-check-profiles'
        : 'stock-take-profiles',
    label: t('stockTakeProfiles.profiles'),
  },
};

export const stockItemsTabs = {
  items: {
    key: 'items',
    label: t('items.items'),
  },
  profiles: {
    key: 'profiles',
    label: t('profiles.profiles'),
  },
  warranties: {
    key: 'warranties',
    label: t('warranties.warranties'),
  },
};
